module.exports = __webpack_public_path__ + "public/Icons/logout.svg?62fb2a9e";